module.exports = __webpack_public_path__ + "static/media/control-icon.ca77da6d.svg";